// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ds3Q","tabsBox":"styles_tabsBox__3cTP9","createButton":"styles_createButton__91CK5"};